module.exports = __webpack_public_path__ + "img/blindkill.97b10eca.svg";